import { Component } from "react";

import ListsContainer from "containers/lists/ListsContainer";

/**
 * PlacesContainer container component
 * export keyword here is used to import this module as a named import
 * useful when running tests
 */
export class PlacesContainer extends Component {
  render() {
    return <ListsContainer {...this.props} customerSection={true} />;
  }
}

/**
 * Connect PlacesContainer container to redux store and map
 * actions to the store and props of this container to
 * state of store
 */
export default PlacesContainer;
